import React from 'react';
import PropTypes from 'prop-types';
import { Footer, Header } from '../Main/components';
import { SlideModel } from '../../components';
import './styles.css'

const AuthLayout = (props) => {
    const { children } = props;
    return (
        <div>
            <Header />
            <main>
            <SlideModel />                                 
                    <div className="row">
                        <div className="col-md-6 auth-image">

                        </div>
                        <div className="col-md-6">
                            {children}
                        </div>
                    </div>
            </main>

            <Footer />
        </div>
    );
}

AuthLayout.propTypes = {
    children: PropTypes.node,
}

export default AuthLayout;
